import PropTypes from "prop-types"
import { useState, useEffect } from "react"

import {
  Text,
  FormContainer,
  FormWrapper,
  MsgWrap,
} from "areas/order/components"
import fetchOrder from "areas/order/hoc/fetch-order"
import OrderNumber from "areas/order/order-number"
import { showHolidayShippingInfo } from "helpers/holiday"

import Heading from "../heading"

import Complete from "./complete"
import EditConfirmation from "./edit-confimation"
import Invalid from "./invalid"
import SelectItemForm from "./select-item-form"

const OrderEdit = ({ data, loading }) => {
  const [orderData, setData] = useState(null)
  const [orderNumber, setOrderNumber] = useState("")

  const [completed, setCompleted] = useState(false)
  const [finishedWizard, setFinishedWizard] = useState(false)

  const [canSubmit, setCanSubmit] = useState(true)
  const [validChanges, setValidChanges] = useState(false)

  useEffect(() => {
    setData(data)
  }, [data])

  if (finishedWizard && completed) {
    return <Complete />
  }

  if (finishedWizard && !validChanges) {
    // No changes

    return <Invalid />
  }

  if (!loading && data && data.order_params) {
    return (
      <EditConfirmation
        canSubmit={canSubmit}
        data={orderData}
        setCanSubmit={setCanSubmit}
        setCompleted={setCompleted}
        setFinishedWizard={setFinishedWizard}
        setValidChanges={setValidChanges}
      />
    )
  }

  if (orderData?.line_items && !orderData.errors) {
    // Choose item to change
    return (
      <SelectItemForm
        canSubmit={canSubmit}
        orderData={orderData}
        orderNumber={orderNumber}
      />
    )
  }

  return (
    <FormContainer>
      <FormWrapper>
        <Heading rmaType="change-order" />
        {showHolidayShippingInfo() && (
          <MsgWrap style={{ borderColor: "#71A056" }}>
            Please note: During this busy {sl.config.guaranteed_holiday} season,
            any changes in your order will affect the estimated shipping date
            and arrival time.
          </MsgWrap>
        )}
        <Text mb={2}>
          Complete this form to make a change to your {sl.config.site_title}{" "}
          order. Please note, changes can only be made to an order if it is not
          yet in production. If you need further assistance, contact customer
          service at{" "}
          <a
            className="nowrap"
            href={`tel:${sl.config.customer_service_toll_free}`}
          >
            {sl.config.customer_service_toll_free}
          </a>{" "}
          or{" "}
          <a
            className="nowrap"
            href={`mailto:${sl.config.customer_service_email}`}
          >
            {sl.config.customer_service_email}
          </a>
          .
        </Text>
        <Text>
          Please enter the following required information so we can help you.
        </Text>
        {orderData?.errors && (
          <Text color="#ff0000" mb={2} mt={2}>
            {orderData.errors[0]}
          </Text>
        )}
      </FormWrapper>
      <OrderNumber
        rmaType={"change"}
        setData={setData}
        setOrderNumber={setOrderNumber}
        validatePath="/secure/api/v10/order/validate_order_change"
      />
    </FormContainer>
  )
}

OrderEdit.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  orderNumber: PropTypes.string,
}

export default fetchOrder(OrderEdit)
